import { useTranslation, Trans } from "react-i18next";
import { IShippingData } from "./interfaces";
import shippingData from "@/i18n/json/shipping-and-returns/en.json";
import ContentHeading from "@/components/content-heading";
import {content, heading, link} from "@/components/terms/styles/terms-data";
import {wrapper} from "./styles/shipping-and-returns-styles";

// Styles


const ShippingData: React.FC<IShippingData> = () => {
    const { t } = useTranslation();

    return (
        <section className={wrapper}>
            <div>
            <ContentHeading
                h="p"
                className="justify-center mb-6"
                backdropPosition="mobile:left-4 tablet:left-8"
                fontSize="mobile:text-3xl tablet:text-5xl"
                background="bg-primary bg-opacity-60"
            >
                Shippings &amp; Returns
            </ContentHeading>
        </div>
            {shippingData["policy"].map((item: IShippingData, index: number) => {
                return (
                    <div key={index}>
                        <p className={heading}>
                            <Trans>
                                <strong>{item.heading}</strong>
                            </Trans>
                        </p>
                        <p className={content}>
                            <Trans components={{ q: <q />, a: <a className={link} /> }}>{item.content}</Trans>
                        </p>
                    </div>
                )
            })}

        </section>
    )
}

export default ShippingData
